import { http } from '../api/http';

export interface ContactData {
  phone?: string | null;
  email?: string | null;
  address?: string | null;
  city?: string | null;
}

export interface UpdateContactDataDto {
  phone?: string;
  email?: string;
  address?: string;
  city?: string;
}

export const ContactDataService = {
  /**
   * Obtiene los datos de contacto del usuario actual
   */
  getContactData() {
    return http<ContactData>('/me/profile/contact');
  },

  /**
   * Actualiza los datos de contacto del usuario actual
   */
  updateContactData(payload: UpdateContactDataDto) {
    return http<ContactData>('/me/profile/contact', { 
      method: 'PUT', 
      body: payload 
    });
  }
};
